import { Loading } from 'components';

function LoadingScreen({
    children = <h3 style={{ textAlign: 'center' }}>Loading...</h3>,
}) {
    return (
        <div className="landing-wrapper v-centered">
            <div className="form">
                <Loading />
                {children}
            </div>
        </div>
    );
}

export default LoadingScreen;
